/**
 * PGS-3499: config values only, no SDK imports here, so this stays trivially
 * importable from the ApolloLink (otelLink.ts) without dragging in the
 * tracer provider bootstrap (otelBrowser.ts).
 *
 * The traces endpoint is unset (export disabled) unless explicitly
 * configured. No deployed environment has a browser-facing OTLP endpoint
 * decided yet, so leaving it unset there is deliberate, not an oversight —
 * see the sibling ticket PGS-3060/PGS-3063/PGS-3064 for gatorade-storefront's
 * equivalent decision.
 *
 * PGS-3553: `propagationEnabled` defaults to `true` — with no endpoint, that
 * default is what turns on propagate-only mode (span created, traceparent
 * injected, span kept active for Sentry tagging, nothing exported) in every
 * environment that hasn't decided otherwise, which is the whole point of
 * this switch: today no deployed environment has a browser-facing OTLP
 * endpoint, so without it none of them get a browser leg or Sentry/OTel
 * correlation at all. Set `NEXT_PUBLIC_OTEL_BROWSER_PROPAGATION_ENABLED` to
 * the literal string `"false"` to fall back to today's behaviour (no
 * provider, no header, no tags) for an environment that needs it off.
 */
export const getOtelConfig = () => ({
  tracesEndpoint:
    process.env.NEXT_PUBLIC_OTEL_EXPORTER_OTLP_TRACES_ENDPOINT || "",
  sampleRatio: parseFloat(
    process.env.NEXT_PUBLIC_OTEL_TRACE_SAMPLE_RATIO || "1"
  ),
  propagationEnabled:
    process.env.NEXT_PUBLIC_OTEL_BROWSER_PROPAGATION_ENABLED !== "false",
});
